import { format } from 'date-fns';

const getFilePath = (): string => {
  return `/files/${format(Date.now(), 'yyyyMMdd')}/`;
};

export default getFilePath;
